<div class='input-group'>
  @if (isIE) {
    <input pcgTime type='text' placeholder="hh:mm AM/PM" [id]='id' [value]='formatValue(value)' (change)="onChange" (touch)="onTouched" class="form-control">
  }
  @if (!isIE) {
    <input type='time' placeholder="hh:mm AM/PM" [id]='id' [value]='value' (change)="onChange" (touch)="onTouched" class="form-control">
  }
  <div class="input-group-append">
    <button class="btn btn-outline-secondary clock" (click)="open()" type="button"></button>
  </div>
</div>
